import { PlantsEnum, SubPlantCodesEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { GrnItems } from "./raw-material-grn-items.entity";
@Entity('grn')
export class Grn {

    @PrimaryGeneratedColumn("increment", { name: 'grn_id' })
    grnId: number;
    @Column({
        nullable: false,
        name: "grn_date"
    })
    grnDate: Date;

    @Column({
        type: 'int',
        nullable: true,
        // default: 0,
        name: 'plant_id'
    })
    plantId: number;

    @Column({
        type: 'int',
        nullable: true,
        // default: 0,
        name: 'sub_plant_id'
    })
    subPlantId: number;

    // @Column({
    //     type: 'enum',
    //     enum: SubPlantCodesEnum,
    //     nullable: true,
    //     // default: SubPlantCodesEnum.KDM,
    //     name: 'sub_plant_id'
    // })
    // subPlantId: SubPlantCodesEnum;

    @Column("int", {
        nullable: false,
        name: "indent_no"
    })
    indentId: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "grn_number"
    })
    grnNumber: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "supplier_type"
    })
    supplierType: string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;


    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(type => GrnItems, grnItems => grnItems.grnInfo, { cascade: true })
    grnItemsInfo: GrnItems[];
}
